export const names = ["Inezinha", "Lucinha", "Zé", "Paulinho", "Cecilia", "Minguinha"];
export const colors = ["#e3320e", "#3a3b9f", "#b20c64", "#071885", "#08dde5", "#21e701"];